import { render, staticRenderFns } from "./BrandSelectionItem.vue?vue&type=template&id=884dd83a&"
import script from "./BrandSelectionItem.vue?vue&type=script&lang=js&"
export * from "./BrandSelectionItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports